module.exports = __webpack_public_path__ + "img/tribeidwhite (1).1f93718a.png";